import { fg } from '@atlassian/jira-feature-gating';
import { isMobileAndInMvpOrExistingUsersExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import { isTailoredOnboardingScrumAndSoftwareKanbanEnabled } from '@atlassian/jira-tailored-onboarding/src/controllers/index.tsx';

export const shouldShowQuickstart = (routeName: RouteName, configQueryParam?: string) => {
	if (isMobileAndInMvpOrExistingUsersExperiment()) {
		return false;
	}

	if (fg('tailored_onboarding_m3_gate') || isTailoredOnboardingScrumAndSoftwareKanbanEnabled()) {
		const allowedRoutes: Set<RouteName> = new Set([
			'software-timeline',
			'software-backlog',
			'software-boards',
			'software-timeline-classic',
			'rapidboard-backlog',
			'rapidboard-board',
			'project-settings-software-access',
			'legacy-project-settings-people',
			'issue',
			'opsgenie-schedule',
			'software-code-classic',
			'software-list',
			'software-list-classic',
			'software-summary',
			'project-pages',
			'software-form',
			'software-calendar',
		]);

		if (isTailoredOnboardingScrumAndSoftwareKanbanEnabled()) {
			allowedRoutes.add('software-code');
		}

		if (fg('software_calendar_quickstart_onboarding')) {
			allowedRoutes.add('software-calendar-classic');
			allowedRoutes.add('software-calendar');
		}

		return allowedRoutes.has(routeName) && configQueryParam === undefined;
	}

	const allowedRoutes: RouteName[] = [
		'software-timeline',
		'software-backlog',
		'software-boards',
		'software-timeline-classic',
		'rapidboard-backlog',
		'rapidboard-board',
		'project-settings-software-access',
		'legacy-project-settings-people',
		'issue',
		'opsgenie-schedule',
		'software-code-classic',
		'software-list',
		'software-list-classic',
	];

	fg('software_calendar_quickstart_onboarding') &&
		allowedRoutes.push('software-calendar-classic', 'software-calendar');

	return allowedRoutes.includes(routeName) && configQueryParam === undefined;
};

// This function mainly performs route detection software project pages that use generic layout
// https://hello.atlassian.net/wiki/spaces/KURO/pages/1666983181/Where+is+QuickStart+displayed+and+why
export const shouldRouteSkipOnboarding = (routeName: RouteName, configQueryParam?: string) =>
	!shouldShowQuickstart(routeName, configQueryParam);
